import { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Portfolio from "../pages/portfolio/page";
import Locations from "../pages/locations/page";
import Contact from "../pages/contact/page";
import Navbar from "../components/feature/Navbar";
import Footer from "../components/feature/Footer";

function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout><Home /></Layout>,
  },
  {
    path: "/services",
    element: <Layout><Services /></Layout>,
  },
  {
    path: "/portfolio",
    element: <Layout><Portfolio /></Layout>,
  },
  {
    path: "/locations",
    element: <Layout><Locations /></Layout>,
  },
  {
    path: "/contact",
    element: <Layout><Contact /></Layout>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
